import { ReactNode, FC } from "react";

import Button from "../../components/Mobile/Button";

type PageSectionProps = {
  imgSrc: string;
  greyBkg?: boolean;
  header: ReactNode;
  description: ReactNode;
  button: {
    label: string;
    onClick: () => void;
  };
};

const PageSection: FC<PageSectionProps> = ({
  imgSrc,
  greyBkg,
  header,
  description,
  button,
}) => {
  return (
    <section className={`px-[20px] py-[40px] ${greyBkg ? "bg-[#F8F8F8]" : ""}`}>
      <img
        src={imgSrc}
        alt="sectionImg"
        className="w-full h-auto object-cover mb-[24px] rounded-[16px]"
      />

      <div className="flex flex-col w-full gap-[8px] mb-[16px]">
        <h4 className="text-[24px] font-raleway font-bold text-primaryDark-0">
          {header}
        </h4>

        <p className="text-[16px] font-open-sans text-text-300">
          {description}
        </p>
      </div>

      <Button
        label={button.label}
        variant="secondary"
        onClick={button.onClick}
      />
    </section>
  );
};

export default PageSection;
